export default __webpack_public_path__ + "static/Oz-Leasing-744402995fbc91bb1c1394c4037503e2.webp";